import React from 'react';
import { Grid, Typography } from '@mui/material';
import { colors } from '../../utils/theme';
import RootineButton from '../../atoms/RootineButton';
import { useNavigate } from 'react-router-dom';

export const DirectToDashboardSection = (): JSX.Element => {
  const navigate = useNavigate();
  return (
    <Grid
      container
      flexDirection="column"
      sx={{
        pt: { xs: 10, md: 50 },
        pb: { xs: 30, md: 20 },
        backgroundImage: `url(/images/go_to_dashboard.jpeg)`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <Grid
        item
        sx={{
          px: { xs: 3, md: 18 },
        }}
      >
        <Typography
          fontSize={48}
          sx={{ color: colors.greys.BASE_WHITE, lineHeight: 'normal' }}
        >
          We've saved your formulation results to your personalized Dashboard
        </Typography>
        <Grid
          item
          sx={{
            mt: 4,
          }}
        >
          <RootineButton
            label="View my dashboard"
            hideIcon
            variation="primary"
            size="large"
            onClick={() => {
              navigate('/');
            }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
